import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LOGIN } from '../utils/utils';
import { DASHBOARDS } from '../utils/utils';

@Component({
    selector: 'app-header',
    template: require('./header.component.html'),
    styles: [require('./header.component.css')]
})

export class HeaderComponent implements OnInit {
    logoUrl:string = "/assets/images/bts_logo.png";
    token:string = "";
    userEmail:string = "";
    loginType:string = "";

    constructor(private dataservice: DataService, private router: Router) {}

    ngOnInit() {
    }

    logout() {
	    if(this.loginType == 'sso') {
	        this.token = null;
	        localStorage.clear();

    		this.router.navigateByUrl('ssologout');
    	} else {
    		this.dataservice.logout(null, null);
	    	this.router.navigateByUrl(LOGIN);    		
    	}
    }

    onIconClick() {
        this.router.navigateByUrl(DASHBOARDS);
    }

    parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    };

    ngDoCheck() {
        this.token = localStorage.getItem('dashboardUser');
        this.loginType = localStorage.getItem('dashboardLoginType');

        if(this.token) {
            let tkn = this.parseJwt(this.token);
            this.userEmail = tkn.email;
            //console.log(this.userEmail);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/header/header.component.ts